// Modules
import React from 'react'
import { useHistory } from 'react-router-dom'

// Aplication
import navIllustration from 'assets/nav-illustration.svg'
import { Analytics } from 'constants/index'
import { useAnalytics } from 'hooks/useAnalytics'
import { useLoginHook } from 'hooks'

// Components
import { TemplateContainerFullWidth } from 'components'
import { Content } from './styles'

export const RegisterExames: React.FC = () => {
    const history = useHistory()
    const { authState } = useLoginHook()
    const shouldRedirect = !authState.signed

    useAnalytics(Analytics.ActivateAccountCipOrphan.RegisterExamesLogin, !shouldRedirect)

    const handleNext = () => {
        history.push('/exames/laboratorios')
    }

    if (shouldRedirect) {
        history.push('/login')
        return null
    }

    return (
        <TemplateContainerFullWidth
            buttonText="Cadastrar exames"
            goTo={handleNext}
            image={navIllustration}
            imageAlt="Ilustração de saudação"
            title="Olá, sou Nav Dasa"
            titleType="medium"
        >
            <Content>
                <p>Para criar um histórico da sua sua saúde em um só lugar, adicione seus exames à sua conta</p>
            </Content>
        </TemplateContainerFullWidth>
    )
}
